import { requireModule } from 'auth/guards';
import { MODULES } from 'auth/permissions';
import LettersCertificatesPage from './pages/LettersCertificates';

export const peopleRoutes = [
  {
    path: '/letters-certificates',
    element: <LettersCertificatesPage />,
    handle: { breadcrumb: 'Letters & Certificates' },
    loader: requireModule(MODULES.LETTERS),
  },
];
